(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/self-exclusion-react/assets/react/components/national-self-exclusion-abtest.js') >= 0) return;  svs.modules.push('/modules/self-exclusion-react/assets/react/components/national-self-exclusion-abtest.js');
'use strict';

const Button = svs.ui.ReactButton;
const Icon = svs.ui.ReactIcon;
const {
  Constants
} = svs.selfExclusion;
const NationalSelfExclusionAbTest = () => {
  const trackInteraction = e => {
    e.preventDefault();
    svs.components.analytics.trackEvent({
      action: 'Submit',
      category: 'spelpaus',
      opt_label: 'NarPaus',
      opt_value: 0
    });
    window.open(Constants.URL.EXCLUSION, '_blank', 'noopener');
  };
  return React.createElement("section", {
    className: "exclusion-pause-wrapper exclusion-rounded-corners padding-xs-h-2 padding-xs-bottom-2"
  }, React.createElement("div", null, React.createElement("h3", {
    className: "align-center f-700 f-bold padding-top-2"
  }, "Spelpaus fr\xE5n alla spelbolag i Sverige"), React.createElement("p", {
    className: "exclusion-text-align"
  }, "Pausen kan vara alltifr\xE5n 1 m\xE5nad till 1 \xE5r och g\xE4ller allt spel som kr\xE4ver registrering hos spelbolag med licens i Sverige.")), React.createElement(Button, {
    block: true,
    iconPosition: "right",
    inverted: true,
    linktitle: Constants.EXCLUSION,
    onClick: trackInteraction,
    size: 300
  }, React.createElement(Icon, {
    icon: "link-external"
  }), "Till spelpaus.se"));
};
svs.selfExclusion.components.NationalSelfExclusionAbTest = NationalSelfExclusionAbTest;

 })(window);